import React from 'react';
import { Badge } from 'reactstrap';

const BadgeCondition = props => (
  <Badge style={{marginRight: '.35rem', fontSize: '.65rem', cursor: 'pointer', textTransform: 'uppercase'}} {...props}/>
)

export default BadgeCondition;